export const ApiPaths = {
  LOGIN: () => `/auth/login`,
  LOGOUT: () => `/auth/logout`,
  GET_CATEGORY: () => `/category/getAll`,
  GET_CATEGORY_DROP_DOWN: () => `/category/getDropDown`,
  CREATE_CATEGORY: '/category/create',
  UPDATE_CATEGORY: (id: string) => `/category/update/${id}`,
  DELETE_CATEGORY: (id: string) => `/category/delete/${id}`,
  GET_STORE: () => `/store/getAllAdmin`,
  GET_STORE_DROP_DOWN: () => `/store/getDropDown`,
  GET_STORE_BY_ID: () => `/store/get`,
  CREATE_STORE: '/store/create',
  UPDATE_STORE: (id: string) => `/store/update/${id}`,
  DELETE_STORE: (id: string) => `/store/delete/${id}`,
  GET_INGREDIENT: () => `/ingredient/getAll`,
  GET_INGREDIENT_DROP_DOWN: () => `/ingredient/getDropDown`,
  UPDATE_INGREDIENT: (id: string) => `/ingredient/update/${id}`,
  CREATE_INGREDIENT: '/ingredient/create',
  DELETE_INGREDIENT: (id: string) => `/ingredient/delete/${id}`,
  GET_PRODUCT_DROP_DOWN: () => `/product/getDropDown`,
  GET_PRODUCT: () => `/product/getAll`,
  GET_PRODUCT_BY_ID: () => `/product/get`,
  CREATE_PRODUCT: '/product/create',
  UPDATE_PRODUCT: (id: string) => `/product/update/${id}`,
  DELETE_PRODUCT: (id: string) => `/product/delete/${id}`,
  GET_STORE_PRODUCT: () => `/store_products/getAll`,
  GET_STORE_PRODUCT_BY_ID: () => `/store_products/get`,
  CREATE_STORE_PRODUCT: '/store_products/create',
  UPDATE_STORE_PRODUCT: (id: string) => `/store_products/update/${id}`,
  DELETE_STORE_PRODUCT: (id: string) => `/store_products/delete/${id}`,
  GET_ORDER: () => `/order/getAll`,
  GET_ORDER_BY_ID: () => `/order/get`,
  UPDATE_ORDER: (id: string) => `/order/update/${id}`,
  COLLECT_COMISSION: '/order/collectComission',
  DOCUMENT_UPLOAD: '/document_upload/files',
  UPDATE_DOCUMENT_UPLOAD: '/document_upload/update_files',
  GET_VERSION: `/version/`,
  UPDATE_VERSION: `/version/`,
  GET_SUPER_MARKET_PRODUCT: `/super_market_products/getAll`,
};
